export function isInViewport(el: HTMLElement): boolean {
    const rect = el.getBoundingClientRect();
    if (rect.top >= window.innerHeight) {
        return false;
    }
    if (rect.bottom < 0) {
        return false;
    }
    if (rect.left >= window.innerWidth) {
        return false;
    }
    if (rect.right < 0) {
        return false;
    }
    return true;
}
